import { connectScheduleMenu, type ScheduleMenuAnalyticProps } from 'components/shared/ScheduledRun/ScheduleMenu';
import type { IdOwnProps } from 'components/shared/ScheduledRun/type';
import { isScheduledRunOnBatchEnabled } from 'state/scheduledRuns/utils';
import { getBatchSchedulableQuotes } from 'state/selectors';

export const ConnectedScheduleMenu = connectScheduleMenu<IdOwnProps & ScheduleMenuAnalyticProps>((state, { id }) => ({
  quotes: getBatchSchedulableQuotes(state, id),
  disabled: !isScheduledRunOnBatchEnabled(state),
  isVisible: true,
}));
